import React from "react";

export default function PrevIcon() {
  return <div>←</div>;
}
